import Lightning from '@lightningjs/core';
import { Img, Utils } from '@lightningjs/sdk';
import { Artwork, Icon } from '@lightningjs/ui-components';

export default class TwoRowThumb extends Lightning.Component {
    static override _template() {
        return {
            w: (w) => w,
            h: (h) => h,
            zIndex: 10,
            // flex: { direction: 'column',alignItems:'center', justifyContent:'center',},
            Image: {
                collision: true,
            }
        }
    }

    override _init() {
        this.patch({
            Image: {
                collision: true,
                SelectedImg: {
                    w: this.finalW,
                    h: this.finalH,
                    src: this.selectedImgSrc,
                    alpha: 0.00000001,
                    // type: Artwork,
                    // fixed: true,
                },
                Img: {
                    w: this.finalW,
                    h: this.finalH,
                    src: this.imgSrc,
                    alpha: 1,
                    // type: Artwork,
                    // fixed: true,
                }
            },
            BlockItem: {
                w: this.finalW,
                h: this.finalH,
                rect: true,
                color: 0xAA222222,
                Icon: {
                    mountX: 1,
                    type: Icon,
                    x: this.finalW - 10,
                    y: 10,
                    w: 50,
                    h: 50,
                    icon: Utils.asset('/svg/ico-block.svg'),
                },
                shader: {},
                visible: this.blockItem
            }
        })

        this.parent.collision = true
    }

    override _focus() {
        this.fireAncestors('$optionsFocused', this.rowIndex, this.itemIndex)
        this.tag('Image').patch({
            SelectedImg: { alpha: 1 },
            Img: { alpha: 0.00000001 }
        })
    }

    override _unfocus() {
        this.tag('Image').patch({
            SelectedImg: { alpha: 0.00000001 },
            Img: { alpha: 1 }
        })
    }

    _handleHover(target) {
        this.parent.parent.selectedIndex = this.itemIndex
        this.parent.parent.parent.parent.selectedIndex = this.rowIndex
        //console.log('TowRowThumb: _handleHover hover: ', target, this.parent.parent.selectedIndex, this.parent.parent.parent.parent.selectedIndex)
        this.fireAncestors('$handleHover', target)
    }

    _handleClick(target) {
        //console.log('TowRowThumb: _handle click: ', this.rowIndex, this.itemIndex, this.parent.parent.selectedIndex)
        this.fireAncestors('$handleThumbClick',target)
        return true
    }
}